export default __webpack_public_path__ + "static/Prainfintech_logo-e72901470268389f4b021a2cb80f2e23.png";